<template>
  <div class="optin">
    <MarkdownCopy
      class="optin__number"
      :content="phoneNumberLabel"
    />
    <MarkdownCopy :content="programText" />
    <MarkdownCopy :content="$t.generalLegalText" />
    <div class="optin__buttons">
      <g-button
        flat
        theme="light"
        size="large"
        class="optin__button optin__button--cancel"
        :dataTestId="{
          host: 'optinCancelButtonHost',
          tag: 'optinCancelButtonTag',
        }"
        @click="handleSelection(OptInEnum.OPT_OUT)"
      >
        {{ $t.declineButtonText }}
      </g-button>
      <g-button
        size="large"
        theme="candy-blue"
        class="optin__button"
        :dataTestId="{
          host: 'optinAcceptButtonHost',
          tag: 'optinAcceptButtonTag',
        }"
        @click="handleSelection(OptInEnum.OPT_IN)"
      >
        {{ $t.acceptButtonText }}
      </g-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStaticGlobal } from '@garmin/vue-static-global';
import '@garmin/components-global-web/dist-web/components/GCopy';
import '@garmin/components-global-web/dist-web/components/GButton';
import useSmsOptInStatusStore from '../store/smsOptInStatus';
import useUserActionsStore from '../store/userAction';
import MarkdownCopy from './MarkdownCopy.vue';
import { OptInEnum, UserActionEnum } from '../constants';

const { translations } = useStaticGlobal();
const smsOptInStatusStore = useSmsOptInStatusStore();
const userActionsStore = useUserActionsStore();

defineOptions({
  name: 'SmsLanding',
});

const phoneNumberLabel = computed(() => `${translations.phoneNumberLabelText} ${smsOptInStatusStore.smsOptInStatus?.phoneNumber}`);
const programText = computed(() => `${translations.programText} ${translations.programConfirmPhoneText} ${translations.programLegalText}`);

const handleSelection = async (status) => {
  const actionObject = {
    [OptInEnum.OPT_IN]: UserActionEnum.SMS_ACCEPT_OPT_IN,
    [OptInEnum.OPT_OUT]: UserActionEnum.SMS_DECLINE_OPT_IN,
  };

  userActionsStore.loadUserAction(actionObject[status]);
  await smsOptInStatusStore.addOptIn(status);
};
</script>

<style lang="scss" scoped>
.optin {
  &__number {
    @include font-accent();
    font-size: 20px;
  }

  &__buttons {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 32px;

    @media only screen and (min-width: $breakpoint) {
      flex-direction: row;
    }

    :first-child {
      margin-bottom: 0;
    }
  }

  &__button {
    width: 100%;
    min-width: 150px;
    height: 50px;
    margin-bottom: 16px;

    :deep(.g__button) {
      display: block;
      width: 100%;
      height: 100%;
      margin: 0;
    }

    @media only screen and (min-width: $breakpoint) {
      width: auto;
    }

    &--cancel {
      margin-right: 0;

      @media only screen and (min-width: $breakpoint) {
        margin-right: 2rem;
      }
    }
  }
}
</style>
